import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-register',
  template: `
    <app-public-layout>
      <ng-container class="title">
        {{ 'register.register' | transloco }}
      </ng-container>

      <ng-container class="content">
        <div class="row">
          <div class="col-lg">
            <app-register-step1-form></app-register-step1-form>
          </div>

          <div class="col-lg">
            <app-register-info-step1></app-register-info-step1>

            <app-button-box text="register.alreadyHaveAccount" buttonText="login.login" path="/login"></app-button-box>
          </div>
        </div>
      </ng-container>
    </app-public-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterComponent {}
